<template>
  <div class="login-body">
    <TopNavbar title="登录"></TopNavbar>
    <div class="login-card-container">
      <LoginCard @loginSuccess="onLoginSuccess"></LoginCard>
    </div>
  </div>
</template>
<script>
  import LoginCard from "../common/LoginCard";
  import TopNavbar from "../common/TopNavbar";

  export default {
    name: "Login",
    components: {TopNavbar, LoginCard},
    methods: {
      onLoginSuccess() {
        this.$router.go(-1)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .login-body {
    padding-top: 65px;
  }

  .login-card-container {
    margin: 15px ;
  }

</style>
